<template>
  <!--
    不用 ContentWrap/ElCard：EP .el-card 默认 overflow:hidden，
    长详情会截断底部且吞掉滚轮，布局 ElScrollbar 滚不动。
  -->
  <div class="order-detail-page">
    <!-- 订单信息 -->
    <el-descriptions title="订单信息">
      <el-descriptions-item label="订单号: ">{{ formData.no }}</el-descriptions-item>
      <el-descriptions-item label="买家: ">{{ formData?.user?.nickname }}</el-descriptions-item>
      <el-descriptions-item label="订单类型: ">
        <dict-tag :type="DICT_TYPE.TRADE_ORDER_TYPE" :value="formData.type!" />
      </el-descriptions-item>
      <el-descriptions-item label="订单来源: ">
        <dict-tag :type="DICT_TYPE.TERMINAL" :value="formData.terminal!" />
      </el-descriptions-item>
      <el-descriptions-item label="买家留言: ">{{ formData.userRemark }}</el-descriptions-item>
      <el-descriptions-item label="商家备注: ">{{ formData.remark }}</el-descriptions-item>
      <el-descriptions-item label="支付单号: ">{{ formData.payOrderId }}</el-descriptions-item>
      <el-descriptions-item label="付款方式: ">
        <template v-if="formData.payChannelCode">
          <dict-tag :type="DICT_TYPE.PAY_CHANNEL_CODE" :value="formData.payChannelCode!" />
          <span v-if="Number(formData.usePoint) > 0" class="ml-8px">
            （消耗积分 {{ formData.usePoint }}）
          </span>
        </template>
        <template v-else-if="formData.payStatus && Number(formData.usePoint) > 0">
          积分兑换（{{ formData.usePoint }} 积分）
        </template>
        <template v-else-if="formData.payStatus">已支付</template>
        <template v-else>未支付</template>
      </el-descriptions-item>
      <el-descriptions-item v-if="Number(formData.usePoint) > 0" label="消耗积分: ">
        {{ formData.usePoint }}
      </el-descriptions-item>
      <el-descriptions-item label="实际付款人: ">
        <template v-if="formData.actualPayerUserId">
          {{ formData.actualPayer?.nickname || formData.actualPayerUserId }}
        </template>
        <template v-else-if="formData.payStatus">本人支付</template>
        <template v-else>—</template>
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.brokerageUser" label="推广用户: ">
        {{ formData.brokerageUser?.nickname }}
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.presaleActivityId" label="预售活动: ">
        {{ formData.presaleActivityId }}
        <span v-if="formData.presaleMode === 1">（全款）</span>
        <span v-else-if="formData.presaleMode === 2">（定金）</span>
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.shipTime" label="预计发货: ">
        {{ formData.shipTime }}
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.payPhase != null" label="预售阶段: ">
        <span v-if="formData.payPhase === 0">待首付</span>
        <span v-else-if="formData.payPhase === 1">待尾款</span>
        <span v-else-if="formData.payPhase === 2">已付清</span>
        <span v-else>{{ formData.payPhase }}</span>
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.depositPrice != null" label="定金: ">
        {{ fenToYuan(formData.depositPrice) }} 元
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.balancePrice != null" label="尾款货款: ">
        {{ fenToYuan(formData.balancePrice) }} 元
      </el-descriptions-item>
      <el-descriptions-item v-if="formData.finalPayStart || formData.finalPayEnd" label="尾款窗口: ">
        {{ formData.finalPayStart || '—' }} ~ {{ formData.finalPayEnd || '—' }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- 订单状态 -->
    <el-descriptions :column="1" title="订单状态">
      <el-descriptions-item label="订单状态: ">
        <el-tag v-if="rentalStatus">{{ rentalStatus }}</el-tag>
        <span v-if="rentalStatus" class="ml-12px">配送进度：</span>
        <dict-tag :type="DICT_TYPE.TRADE_ORDER_STATUS" :value="formData.status!" />
      </el-descriptions-item>
      <el-descriptions-item v-hasPermi="['trade:order:update']" label-class-name="no-colon">
        <el-button
          v-if="formData.status! === TradeOrderStatusEnum.UNPAID.status"
          type="primary"
          @click="updatePrice"
        >
          调整价格
        </el-button>
        <el-button type="primary" @click="remark">备注</el-button>
        <!-- 待发货 -->
        <template v-if="formData.status! === TradeOrderStatusEnum.UNDELIVERED.status">
          <!-- 快递发货 -->
          <el-button
            v-if="formData.deliveryType === DeliveryTypeEnum.EXPRESS.type"
            type="primary"
            @click="delivery"
          >
            发货
          </el-button>
          <el-button
            v-if="formData.deliveryType === DeliveryTypeEnum.EXPRESS.type"
            type="primary"
            @click="updateAddress"
          >
            修改地址
          </el-button>
          <!-- 到店自提 -->
          <el-button
            v-if="formData.deliveryType === DeliveryTypeEnum.PICK_UP.type && showPickUp"
            type="primary"
            @click="handlePickUp"
          >
            核销
          </el-button>
        </template>
      </el-descriptions-item>
      <el-descriptions-item>
        <template #label><span style="color: red">提醒: </span></template>
        买家付款成功后，货款将直接进入您的商户号（微信、支付宝）<br />
        请及时关注你发出的包裹状态，确保可以配送至买家手中 <br />
        如果买家表示没收到货或货物有问题，请及时联系买家处理，友好协商
      </el-descriptions-item>
    </el-descriptions>

    <!-- O2O 服务信息 -->
    <el-descriptions v-if="isO2oOrder" title="服务信息" :column="3">
      <el-descriptions-item label="履约方式: ">
        {{ fulfillmentTypeLabel(formData.fulfillmentType) }}
      </el-descriptions-item>
      <el-descriptions-item label="机构: ">{{ o2oDetail.institutionName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="师傅: ">{{ o2oDetail.providerName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="预约日期: ">
        {{ o2oDetail.reservation?.appointmentDate || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="预约时段: ">
        {{ o2oDetail.reservation?.appointmentTime || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="服务地址: " :span="3">
        {{ o2oDetail.reservation?.address || formData.receiverDetailAddress }}
      </el-descriptions-item>
      <el-descriptions-item v-hasPermi="['trade:order:update']" :span="3" label-class-name="no-colon">
        <el-button v-if="isO2oIntervenable" type="danger" @click="handleForceCancel">强制取消</el-button>
        <el-button v-if="isO2oIntervenable" type="success" @click="handleForceComplete">强制完成</el-button>
        <el-button v-hasPermi="['o2o:dispatch:query']" type="primary" plain @click="goDispatchMonitor">
          派单监控
        </el-button>
      </el-descriptions-item>
    </el-descriptions>

    <!-- 上门服务码（客服管理） -->
    <el-descriptions v-if="isHomeOrder" title="上门服务码" :column="3">
      <el-descriptions-item label="状态: ">
        <el-tag :type="serviceVerifyStatusTag" size="small">{{ serviceVerifyStatusLabel }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="服务码: ">
        <span v-if="o2oDetail.serviceVerifyCode" class="service-verify-code">{{
          o2oDetail.serviceVerifyCode
        }}</span>
        <span v-else class="text-gray-400">未生成</span>
        <el-link
          v-if="o2oDetail.serviceVerifyCode"
          class="ml-8px"
          :underline="false"
          icon="ep:document-copy"
          type="primary"
          @click="handleCopyServiceVerifyCode"
        >
          复制
        </el-link>
      </el-descriptions-item>
      <el-descriptions-item label="核销时间: ">
        {{ o2oDetail.serviceVerifyTime ? formatDate(o2oDetail.serviceVerifyTime) : '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="核销师傅: " :span="2">
        {{ o2oDetail.serviceVerifyProviderName || '-' }}
        <span v-if="o2oDetail.serviceVerifyProviderId" class="text-gray-400">
          （ID {{ o2oDetail.serviceVerifyProviderId }}）
        </span>
      </el-descriptions-item>
      <el-descriptions-item v-hasPermi="['trade:order:update']" :span="3" label-class-name="no-colon">
        <el-button v-if="canRegenerateServiceCode" type="warning" @click="handleRegenerateServiceCode">
          重新生成服务码
        </el-button>
        <span v-if="canRegenerateServiceCode" class="ml-12px text-gray-400 text-12px">
          旧码立即失效；请同步告知用户新码
        </span>
        <span
          v-else-if="o2oDetail.serviceVerifyStatus === 'VERIFIED'"
          class="text-gray-400 text-12px"
        >
          已核销，不可重发；异常结单请用「强制完成」
        </span>
      </el-descriptions-item>
    </el-descriptions>

    <!-- O2O 现场图片：用户下单图 + 师傅服务图（O2O 单始终展示） -->
    <el-card v-if="isO2oOrder" class="o2o-images-card mb-16px" shadow="never">
      <template #header>
        <div class="o2o-images-header">
          <span class="o2o-images-title">现场图片</span>
          <span class="o2o-images-sub">用户下单 / 师傅服务</span>
        </div>
      </template>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="o2o-images-block">
            <div class="o2o-images-label">
              用户下单图
              <el-tag size="small" type="info" class="ml-8px">{{ orderImages.length }} 张</el-tag>
            </div>
            <div v-if="orderImages.length" class="o2o-image-row">
              <el-image
                v-for="(url, idx) in orderImages"
                :key="'order-' + idx"
                :src="url"
                :preview-src-list="orderImages"
                :initial-index="idx"
                fit="cover"
                class="o2o-thumb"
                preview-teleported
              />
            </div>
            <el-empty v-else description="用户下单时未上传现场图" :image-size="56" />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="o2o-images-block">
            <div class="o2o-images-label">
              师傅服务图
              <el-tag size="small" type="info" class="ml-8px">{{ providerServiceImages.length }} 张</el-tag>
            </div>
            <div v-if="providerServiceImages.length" class="o2o-image-row">
              <el-image
                v-for="(url, idx) in providerServiceImages"
                :key="'svc-' + idx"
                :src="url"
                :preview-src-list="providerServiceImages"
                :initial-index="idx"
                fit="cover"
                class="o2o-thumb"
                preview-teleported
              />
            </div>
            <el-empty v-else description="师傅完工时未上传服务图" :image-size="56" />
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- O2O 派单流水 -->
    <el-descriptions v-if="isO2oOrder" title="派单流水" :column="1">
      <el-descriptions-item labelClassName="no-colon">
        <el-timeline v-if="dispatchRecords.length">
          <el-timeline-item
            v-for="item in dispatchRecords"
            :key="item.id"
            :timestamp="formatDate(item.createTime!)"
            placement="top"
          >
            {{ dispatchTypeLabel(item.dispatchType) }} → {{ item.targetName || targetTypeLabel(item.targetType) }}
            <el-tag class="ml-8px" size="small">{{ statusLabel(item.status) }}</el-tag>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无派单流水" :image-size="60" />
      </el-descriptions-item>
    </el-descriptions>

    <!-- 商品/服务信息：通栏表格，避免 span 溢出挤扁商品名 -->
    <el-descriptions :title="isO2oOrder ? '服务信息' : '商品信息'">
      <el-descriptions-item labelClassName="no-colon" class="order-items-desc">
        <el-table :data="formData.items" border class="order-items-table w-full">
          <el-table-column :label="isO2oOrder ? '服务' : '商品'" prop="spuName" min-width="240">
            <template #default="{ row }">
              <div class="order-item-spu flex items-start gap-8px">
                <el-image
                  v-if="row.picUrl"
                  :preview-src-list="[row.picUrl]"
                  :src="row.picUrl"
                  class="!h-45px !w-45px flex-none"
                  fit="cover"
                />
                <div class="order-item-spu__text min-w-0 leading-normal break-words whitespace-normal">
                  {{ itemDisplayName(row) }}
                  <el-tag
                    v-for="property in row.properties"
                    :key="property.propertyId"
                    class="ml-4px mt-4px"
                  >
                    {{ property.propertyName }}: {{ property.valueName }}
                  </el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="!isO2oOrder" label="货源渠道" width="100">
            <template #default="{ row }">{{ row.sourceChannelName || '-' }}</template>
          </el-table-column>
          <el-table-column v-if="!isO2oOrder" label="货源链接" min-width="80" show-overflow-tooltip>
            <template #default="{ row }">
              <el-link
                v-if="row.sourceUrl"
                :href="row.sourceUrl"
                :underline="false"
                target="_blank"
                type="primary"
              >
                打开
              </el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!isO2oOrder" label="商品来源" width="90">
            <template #default="{ row }">{{ row.productSourceName || '-' }}</template>
          </el-table-column>
          <el-table-column v-if="!isO2oOrder" label="供应商" min-width="100" show-overflow-tooltip>
            <template #default="{ row }">{{ row.supplierName || '-' }}</template>
          </el-table-column>
          <el-table-column v-if="!isO2oOrder" label="结算价(件)" width="110">
            <template #default="{ row }">
              <span v-if="row.supplierSettlePrice != null">
                {{ fenToYuan(row.supplierSettlePrice) }}元
                <el-tooltip v-if="row.supplierSettlePriceSourceName" :content="row.supplierSettlePriceSourceName">
                  <span class="text-gray-400 text-12px">·回落</span>
                </el-tooltip>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column :label="isO2oOrder ? '原价' : '商品原价'" prop="price" width="110">
            <template #default="{ row }">{{ fenToYuan(row.price) }}元</template>
          </el-table-column>
          <el-table-column label="数量" prop="count" width="70" />
          <el-table-column label="合计" prop="payPrice" width="110">
            <template #default="{ row }">{{ fenToYuan(row.payPrice) }}元</template>
          </el-table-column>
          <el-table-column label="售后状态" prop="afterSaleStatus" width="100">
            <template #default="{ row }">
              <dict-tag
                :type="DICT_TYPE.TRADE_ORDER_ITEM_AFTER_SALE_STATUS"
                :value="row.afterSaleStatus"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :column="4">
      <!-- 第一层 -->
      <el-descriptions-item label="商品总额: ">
        {{ fenToYuan(formData.totalPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item label="运费金额: ">
        {{ fenToYuan(formData.deliveryPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item label="订单调价: ">
        {{ fenToYuan(formData.adjustPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item v-for="item in 1" :key="item" label-class-name="no-colon" />
      <!-- 优惠构成（按价算链：专享/活动 → VIP → 券 → 积分） -->
      <el-descriptions-item>
        <template #label>
          <span style="color: red">
            {{ formData.type === 4 ? '积分兑换/活动优惠: ' : '①活动优惠(专享/满减等): ' }}
          </span>
        </template>
        {{ fenToYuan(formData.discountPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item>
        <template #label><span style="color: red">②VIP 优惠: </span></template>
        {{ fenToYuan(formData.vipPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item>
        <template #label><span style="color: red">③优惠券: </span></template>
        {{ fenToYuan(formData.couponPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item>
        <template #label><span style="color: red">④积分抵扣: </span></template>
        {{ fenToYuan(formData.pointPrice!) }} 元
      </el-descriptions-item>
      <el-descriptions-item v-if="Number(formData.usePoint) > 0">
        <template #label><span style="color: red">消耗积分: </span></template>
        {{ formData.usePoint }}
      </el-descriptions-item>
      <!-- 第三层 -->
      <el-descriptions-item v-for="item in 3" :key="item" label-class-name="no-colon" />
      <el-descriptions-item label="应付金额: ">
        {{ fenToYuan(formData.payPrice!) }} 元
      </el-descriptions-item>
    </el-descriptions>

    <!-- 物流信息：descriptions-item 不可被 div 包裹 -->
    <el-descriptions v-if="!isO2oOrder" :column="4" title="收货信息">
      <el-descriptions-item label="配送方式: ">
        <dict-tag :type="DICT_TYPE.TRADE_DELIVERY_TYPE" :value="formData.deliveryType!" />
      </el-descriptions-item>
      <el-descriptions-item label="收货人: ">{{ formData.receiverName }}</el-descriptions-item>
      <el-descriptions-item label="联系电话: ">{{ formData.receiverMobile }}</el-descriptions-item>
      <el-descriptions-item
        v-if="
          formData.deliveryType === DeliveryTypeEnum.EXPRESS.type && formData.receiverDetailAddress
        "
        label="收货地址: "
      >
        {{ formData.receiverAreaName }} {{ formData.receiverDetailAddress }}
        <el-link
          :underline="false"
          icon="ep:document-copy"
          type="primary"
          @click="handleCopyReceiverAddress"
        />
      </el-descriptions-item>
      <el-descriptions-item
        v-if="formData.deliveryType === DeliveryTypeEnum.EXPRESS.type && formData.logisticsId"
        label="物流公司: "
      >
        {{ deliveryExpressList.find((item) => item.id === formData.logisticsId)?.name }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="formData.deliveryType === DeliveryTypeEnum.EXPRESS.type && formData.logisticsId"
        label="运单号: "
      >
        {{ formData.logisticsNo }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="formData.deliveryType === DeliveryTypeEnum.EXPRESS.type && formData.deliveryTime"
        label="发货时间: "
      >
        {{ formatDate(formData.deliveryTime) }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="formData.deliveryType === DeliveryTypeEnum.PICK_UP.type && formData.pickUpStoreId"
        label="自提门店: "
      >
        {{ pickUpStore?.name }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="formData.deliveryType === DeliveryTypeEnum.EXPRESS.type && expressTrackList.length > 0"
        :span="4"
        label="物流详情: "
      >
        <el-timeline class="express-timeline">
          <el-timeline-item
            v-for="(express, index) in expressTrackList"
            :key="index"
            :timestamp="formatDate(express.time)"
          >
            {{ express.content }}
          </el-timeline-item>
        </el-timeline>
      </el-descriptions-item>
    </el-descriptions>

    <!-- 订单日志 -->
    <el-descriptions title="订单操作日志">
      <el-descriptions-item labelClassName="no-colon">
        <el-timeline class="order-log-timeline">
          <el-timeline-item
            v-for="(log, index) in formData.logs"
            :key="index"
            :timestamp="formatDate(log.createTime!)"
            placement="top"
          >
            <div class="el-timeline-right-content">
              {{ log.content }}
            </div>
            <template #dot>
              <span
                :style="{ backgroundColor: getUserTypeColor(log.userType!) }"
                class="dot-node-style"
              >
                {{ getDictLabel(DICT_TYPE.USER_TYPE, log.userType)[0] }}
              </span>
            </template>
          </el-timeline-item>
        </el-timeline>
      </el-descriptions-item>
    </el-descriptions>
  </div>

  <!-- 各种操作的弹窗 -->
  <OrderDeliveryForm ref="deliveryFormRef" @success="getDetail" />
  <OrderUpdateRemarkForm ref="updateRemarkForm" @success="getDetail" />
  <OrderUpdateAddressForm ref="updateAddressFormRef" @success="getDetail" />
  <OrderUpdatePriceForm ref="updatePriceFormRef" @success="getDetail" />
</template>
<script lang="ts" setup>
import * as RentalOrderApi from '@/api/rental/order'

import * as TradeOrderApi from '@/api/mall/trade/order'
import { copy, fenToYuan } from '@/utils'
import { formatDate } from '@/utils/formatTime'
import { DICT_TYPE, getDictLabel, getDictObj } from '@/utils/dict'
import OrderUpdateRemarkForm from '@/views/mall/trade/order/form/OrderUpdateRemarkForm.vue'
import OrderDeliveryForm from '@/views/mall/trade/order/form/OrderDeliveryForm.vue'
import OrderUpdateAddressForm from '@/views/mall/trade/order/form/OrderUpdateAddressForm.vue'
import OrderUpdatePriceForm from '@/views/mall/trade/order/form/OrderUpdatePriceForm.vue'
import * as DeliveryExpressApi from '@/api/mall/trade/delivery/express'
import { useTagsViewStore } from '@/store/modules/tagsView'
import { DeliveryTypeEnum, TradeOrderStatusEnum, isO2oOrderStatus } from '@/utils/constants'
import * as O2oOrderApi from '@/api/o2o/order'
import { O2oDispatchApi } from '@/api/o2o/dispatch'
import * as DeliveryPickUpStoreApi from '@/api/mall/trade/delivery/pickUpStore'
import { propTypes } from '@/utils/propTypes'
import { useMallStandaloneNav } from '@/hooks/web/useMallStandaloneNav'

defineOptions({ name: 'TradeOrderDetail' })

const message = useMessage() // 消息弹窗
const { pushMall } = useMallStandaloneNav()

/** 获得 userType 颜色 */
const getUserTypeColor = (type: number) => {
  const dict = getDictObj(DICT_TYPE.USER_TYPE, type)
  switch (dict?.colorType) {
    case 'success':
      return '#67C23A'
    case 'info':
      return '#909399'
    case 'warning':
      return '#E6A23C'
    case 'danger':
      return '#F56C6C'
  }
  return '#409EFF'
}

// 订单详情
const formData = ref<TradeOrderApi.OrderVO>({
  items: [],
  logs: []
})
const o2oDetail = ref<O2oOrderApi.O2oOrderDetailVO>({ order: {}, items: [] })
const dispatchRecords = ref<any[]>([])

const dispatchTypeOptions = [
  { label: '平台派单', value: 'PLATFORM' },
  { label: '机构内派', value: 'INSTITUTION' },
  { label: '抢单', value: 'GRAB' }
]
const dispatchStatusOptions = [
  { label: '待处理', value: 'PENDING' },
  { label: '已接受', value: 'ACCEPTED' },
  { label: '已拒绝', value: 'REJECTED' },
  { label: '已超时', value: 'TIMEOUT' }
]
const dispatchTypeLabel = (v?: string) => dispatchTypeOptions.find((o) => o.value === v)?.label || v || '-'
const targetTypeLabel = (v?: string) => (v === 'INSTITUTION' ? '机构' : v === 'PROVIDER' ? '师傅' : v || '-')
const statusLabel = (v?: string) => dispatchStatusOptions.find((o) => o.value === v)?.label || v || '-'

const isO2oOrder = computed(
  () => formData.value.fulfillmentType === 'HOME' || formData.value.fulfillmentType === 'STORE'
)
const isHomeOrder = computed(() => formData.value.fulfillmentType === 'HOME')
const isO2oIntervenable = computed(() => isO2oOrderStatus(formData.value.status))

const serviceVerifyStatusLabel = computed(() => {
  const map: Record<string, string> = {
    NONE: '未生成',
    PENDING: '待核销',
    VERIFIED: '已核销',
    'N/A': '不适用'
  }
  return map[o2oDetail.value.serviceVerifyStatus || ''] || o2oDetail.value.serviceVerifyStatus || '-'
})
const serviceVerifyStatusTag = computed(() => {
  const map: Record<string, string> = {
    NONE: 'info',
    PENDING: 'warning',
    VERIFIED: 'success',
    'N/A': 'info'
  }
  return map[o2oDetail.value.serviceVerifyStatus || ''] || 'info'
})
/** 上门 + 履约中(50–54) + 未核销 → 可重发 */
const canRegenerateServiceCode = computed(() => {
  if (!isHomeOrder.value) return false
  if (o2oDetail.value.serviceVerifyStatus === 'VERIFIED') return false
  const status = formData.value.status
  return status != null && status >= TradeOrderStatusEnum.O2O_WAIT_DISPATCH.status
    && status <= TradeOrderStatusEnum.O2O_IN_SERVICE.status
})
const orderImages = computed(() => {
  const fromApi = o2oDetail.value.orderImages
  if (fromApi?.length) return fromApi
  // 兜底：直接从订单 serviceContext 解析（兼容旧接口或字段未展开）
  return normalizeImageUrls(o2oDetail.value.order?.serviceContext?.orderImages)
})
const providerServiceImages = computed(() => {
  const fromApi = o2oDetail.value.providerServiceImages
  if (fromApi?.length) return fromApi
  return normalizeImageUrls(o2oDetail.value.order?.serviceContext?.providerServiceImages)
})

function normalizeImageUrls(raw: unknown): string[] {
  if (!raw) return []
  if (typeof raw === 'string') {
    const s = raw.trim()
    if (!s) return []
    if (s.startsWith('[')) {
      try {
        return normalizeImageUrls(JSON.parse(s))
      } catch {
        return [s]
      }
    }
    return [s]
  }
  if (!Array.isArray(raw)) return []
  const urls: string[] = []
  for (const item of raw) {
    if (typeof item === 'string' && item.trim()) {
      urls.push(item.trim())
      continue
    }
    if (item && typeof item === 'object') {
      const obj = item as Record<string, unknown>
      const url = obj.url || obj.fileUrl || obj.path
      if (typeof url === 'string' && url.trim()) urls.push(url.trim())
    }
  }
  return [...new Set(urls)]
}

const itemDisplayName = (row: TradeOrderApi.OrderItemRespVO) => {
  const snapshot = row.serviceSnapshot as Record<string, any> | undefined
  const name = snapshot?.serviceName || row.spuName || '-'
  return String(name).replace(/^\[O2O\]\s*/i, '').replace(/^【O2O】\s*/i, '').trim() || '-'
}

const fulfillmentTypeLabel = (type?: string) => {
  if (type === 'HOME') return '上门服务'
  if (type === 'STORE') return '到店服务'
  return type || '-'
}

const loadO2oDetail = async () => {
  if (!isO2oOrder.value || !formData.value.id) return
  o2oDetail.value = await O2oOrderApi.getO2oOrderDetail(formData.value.id)
  dispatchRecords.value = await O2oDispatchApi.listByOrder(formData.value.id)
}

const goDispatchMonitor = () => {
  push({ name: 'O2oDispatch', query: { orderId: String(formData.value.id) } })
}

const handleForceCancel = async () => {
  const { value } = await message.prompt('请输入强制取消原因（可选）', '平台强制取消')
  await O2oOrderApi.forceCancelO2oOrder({ id: formData.value.id!, reason: value })
  message.success('已强制取消')
  await getDetail()
}

const handleForceComplete = async () => {
  const { value } = await message.prompt(
    '强制完成将绕过服务码核销，请输入原因（可选）',
    '平台强制完成'
  )
  await O2oOrderApi.forceCompleteO2oOrder({ id: formData.value.id!, reason: value })
  message.success('已强制完成')
  await getDetail()
}

const handleRegenerateServiceCode = async () => {
  try {
    await message.confirm('确认重新生成服务码？旧码将立即失效，需通知用户使用新码。')
    const code = await O2oOrderApi.regenerateServiceVerifyCode(formData.value.id!)
    message.success(`新服务码：${code}`)
    await loadO2oDetail()
  } catch {}
}

/** 各种操作 */
const updateRemarkForm = ref() // 订单备注表单 Ref
const remark = () => {
  updateRemarkForm.value?.open(formData.value)
}
const deliveryFormRef = ref() // 发货表单 Ref
const delivery = () => {
  deliveryFormRef.value?.open(formData.value)
}
const updateAddressFormRef = ref() // 收货地址表单 Ref
const updateAddress = () => {
  updateAddressFormRef.value?.open(formData.value)
}
const updatePriceFormRef = ref() // 订单调价表单 Ref
const updatePrice = () => {
  updatePriceFormRef.value?.open(formData.value)
}

/** 核销 */
const handlePickUp = async () => {
  try {
    // 二次确认
    await message.confirm('确认核销订单吗？')
    // 提交
    await TradeOrderApi.pickUpOrder(formData.value.id!)
    message.success('核销成功')
    // 刷新列表
    await getDetail()
  } catch {}
}

/** 获得详情 */
const { params, query: detailQuery } = useRoute()
const rentalStatus = ref('')
const props = defineProps({
  id: propTypes.number.def(undefined), // 订单ID
  showPickUp: propTypes.bool.def(true) // 显示核销按钮
})
const id = Number(params.id || props.id)
const getDetail = async () => {
  if (id) {
    const res = (await TradeOrderApi.getOrder(id)) as TradeOrderApi.OrderVO
    // 没有表单信息则关闭页面返回
    if (!res) {
      message.error('交易订单不存在')
      close()
    }
    formData.value = res
    if (detailQuery.rentalOrderId) {
      const rental = await RentalOrderApi.getOrder(Number(detailQuery.rentalOrderId))
      rentalStatus.value = rental.tradeOrderId === id ? getDictLabel(DICT_TYPE.RENTAL_ORDER_STATUS, rental.status) || '处理中' : ''
    }
    await loadO2oDetail()
  }
}

/** 关闭 tag */
const { delView } = useTagsViewStore() // 视图操作
const { push, currentRoute } = useRouter() // 路由
const close = () => {
  delView(unref(currentRoute))
  pushMall('/trade/order')
}

/** 复制上门服务码（完整 6 位，避免 v-clipboard 未更新/未注册导致拷不全） */
const handleCopyServiceVerifyCode = async () => {
  const code = String(o2oDetail.value.serviceVerifyCode || '').trim()
  if (!code) {
    message.warning('暂无服务码')
    return
  }
  await copy(code, `服务码已复制：${code}`)
}

/** 复制收货地址 */
const handleCopyReceiverAddress = async () => {
  const text = [formData.value.receiverAreaName, formData.value.receiverDetailAddress]
    .filter(Boolean)
    .join(' ')
    .trim()
  if (!text) {
    message.warning('暂无收货地址')
    return
  }
  await copy(text, '地址已复制')
}

/** 初始化 **/
const deliveryExpressList = ref<DeliveryExpressApi.DeliveryExpressVO[]>([]) // 物流公司
const expressTrackList = ref<Array<{ time?: Date | string; content?: string }>>([]) // 物流详情
const pickUpStore = ref<DeliveryPickUpStoreApi.DeliveryPickUpStoreVO>() // 自提门店
onMounted(async () => {
  await getDetail()
  // 如果配送方式为快递，则查询物流公司
  if (formData.value.deliveryType === DeliveryTypeEnum.EXPRESS.type) {
    deliveryExpressList.value = await DeliveryExpressApi.getSimpleDeliveryExpressList()
    if (formData.value.logisticsId) {
      expressTrackList.value = await TradeOrderApi.getExpressTrackList(formData.value.id!)
    }
  } else if (formData.value.deliveryType === DeliveryTypeEnum.PICK_UP.type) {
    if (formData.value.pickUpStoreId) {
      pickUpStore.value = await DeliveryPickUpStoreApi.getDeliveryPickUpStore(
        formData.value.pickUpStoreId
      )
    }
  }
  // 异步内容撑高后，触发布局滚动区域重算
  await nextTick()
  window.dispatchEvent(new Event('resize'))
})
</script>
<style lang="scss" scoped>
/* 详情根节点：内容自然撑高；滚动由独立壳 / 经典布局的滚动条负责 */
.order-detail-page {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 24px;
  overflow: visible;
  background-color: var(--el-bg-color);
  border-radius: var(--el-card-border-radius);
}

.service-verify-code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.04em;
  user-select: all;
}
.o2o-image-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.o2o-thumb {
  width: 88px;
  height: 88px;
  border-radius: 8px;
  border: 1px solid var(--el-border-color-lighter);
  cursor: zoom-in;
}
.o2o-images-card {
  :deep(.el-card__header) {
    padding: 12px 16px;
  }
}
.o2o-images-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.o2o-images-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--el-text-color-primary);
}
.o2o-images-sub {
  font-size: 12px;
  color: var(--el-text-color-secondary);
}
.o2o-images-block {
  min-height: 120px;
  padding: 8px 4px;
}
.o2o-images-label {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--el-text-color-regular);
}

:deep(.el-descriptions) {
  &:not(:nth-child(1)) {
    margin-top: 20px;
  }

  .el-descriptions__title {
    display: flex;
    align-items: center;

    &::before {
      display: inline-block;
      width: 3px;
      height: 20px;
      margin-right: 10px;
      background-color: #409eff;
      content: '';
    }
  }

  .el-descriptions-item__container {
    margin: 0 10px;

    .no-colon {
      margin: 0;

      &::after {
        content: '';
      }
    }
  }
}

/* 商品表：单元格允许多行换行，避免长标题叠字裁切 */
.order-items-table {
  :deep(.el-table__cell) {
    vertical-align: top;
  }
  :deep(.cell) {
    white-space: normal;
    line-height: 1.5;
  }
}
.order-item-spu__text {
  word-break: break-word;
}

/* 物流轨迹：普通时间线，不套订单日志的左偏移 */
.express-timeline {
  margin: 8px 0 0;
  padding-left: 4px;
  max-width: 100%;
}

/* 订单操作日志时间线（左时间戳布局） */
:deep(.order-log-timeline.el-timeline) {
  margin: 10px 0 0 160px;

  .el-timeline-item__wrapper {
    position: relative;
    top: -20px;

    .el-timeline-item__timestamp {
      position: absolute !important;
      top: 10px;
      left: -150px;
    }
  }

  .el-timeline-right-content {
    display: flex;
    min-height: 30px;
    padding: 10px;
    background-color: var(--app-content-bg-color);
    border-radius: var(--el-card-border-radius);
    align-items: center;

    &::before {
      position: absolute;
      top: 10px;
      left: 13px;
      border-color: transparent var(--app-content-bg-color) transparent transparent;
      border-style: solid;
      border-width: 8px;
      content: '';
    }
  }

  .dot-node-style {
    position: absolute;
    left: -5px;
    display: flex;
    width: 20px;
    height: 20px;
    font-size: 10px;
    color: #fff;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
  }
}
</style>
